export default __webpack_public_path__ + "static/media/349D.fdc90d0d.jpg";